export default "__VITE_ASSET__cu3Z6t1V__"